import {
  AfterViewInit,
  Component,
  computed,
  ElementRef,
  OnInit,
  QueryList,
  signal,
  ViewChildren
} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CookieService} from '../services/cookie.service';
import {RciApiService} from '../services/rci-api.service';
import {ThemeService} from '../services/theme.service';
import {AgeCalculationService} from '../services/age-calculation.service';
import {ModelService} from '../services/model.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {CurrencyPipe, DecimalPipe} from '@angular/common';
import {environment} from "../../environments/environment";
import {DafaultIfNullPipe} from "../pipes/dafault-if-null.pipe";
import {FormsModule} from "@angular/forms";
import {NouisliderModule} from "ng2-nouislider";
import {NgxTippyModule} from "ngx-tippy-wrapper";
import {TooltipDirective} from "../directives/tooltip.directive";


@Component({
  standalone: true,
  selector: 'app-calculator-index',
  templateUrl: './calculator-index.component.html',
  imports: [
    CurrencyPipe,
    DafaultIfNullPipe,
    FormsModule,
    NouisliderModule,
    NgxTippyModule,
    TooltipDirective
  ],
  styleUrls: ['./calculator-index.component.css']
})

export class CalculatorIndexComponent implements OnInit, AfterViewInit {
  public conditionsResponse;
  public conditionParams;
  public delay = 1000;
  public calculating: boolean = false;
  public validCallingSystems = ['01', '02', '03', '04', '05', '06'];
  public paramInvalid = false;

  contractKind = signal<any>(undefined);
  tooltipContentInfo = computed(() => {
    if (this.contractKind()) {
      console.log('tooltipContentInfo', this.contractKind().contentInfo)
      return this.contractKind().contentInfo;
    }
    console.log('tooltipContentInfo', "nöö")
    return "nöö";
  });

  productInfo: string[] = [
    'Vario Finanzierung: Bei einer Vario-Finanzierung bezahlen Sie konstante Monatsraten über die gesamte Finanzierungslaufzeit.',
    '2-Wege Finanzierung: Bei einer 2-Wege-Finanzierung stehen Ihnen zwei Optionen am Vertragsende zur Verfügung: Zahlung oder Weiterfinanzierung der Schlussrate.',
    '3-Wege Finanzierung: Bei einer 3-Wege-Finanzierung stehen Ihnen drei Optionen am Vertragsende zur Verfügung: Übernahme des Fahrzeugs und Zahlung der Schlussrate, Weiterfinanzierung der Schlussrate oder Rückkauf des Fahrzeugs durch den Händler.',
    'Kilometerleasing: Bei einem Kilometerleasing zahlen Sie nur für das, was Sie auch nutzen. Am Ende der Leasinglaufzeit geben Sie das Fahrzeug einfach Ihrem Händler zurück.'
  ];

  public vehicle: any = {};
  private tooltipsInitialized = false;

  constructor(public cookieService: CookieService,
              public themeService: ThemeService,
              public ageCalculation: AgeCalculationService,
              public rciApi: RciApiService,
              public activatedRoute: ActivatedRoute,
              public model: ModelService,
              private decimalPipe: DecimalPipe) {
  }

  @ViewChildren('tooltipIcon') tooltipElements: QueryList<ElementRef>;

  ngOnInit() {
    this.model.view = {
      showPlaceholder: true,
      showContactYourDealer: false,
      birthYears: this.ageCalculation.birthyearsFromTo(18, 65),
      birthYear: this.ageCalculation.birthYearFromAge(45),
      showInvalidCondition: false,
      popcheckmessage: null,
      showSolvency: false
    };
    this.model.setEmptySettings();
    this.mapParams();
  }

  isDealerEmailInvalid(dealerEmail) {
    let regex = /^.{2,}@.{2,}[.].{2,}$/;
    // let regex = /^(?!(^[.].*|[^@]*[.]@|.*\\.{2,}.*)|^.{254}.)([a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}.\-]{2,}@)(?!-.*|.*-\\.)([a-zA-Z0-9-]{2,63}\\.)+[a-zA-Z]{2,15}$/;
    return !dealerEmail || regex.test(dealerEmail) === false;
  }

  isBrandInvalid(brand) {
    let validBrands = ['REN', 'NIS', 'RCI', 'DAC'];
    return !brand || validBrands.indexOf(brand) === -1;
  }

  isBrandInvalidForDealer(brand, rciNetNumber) {
    let netNumber = parseInt(rciNetNumber);
    if (isNaN(netNumber)) {
      console.log('Incorrect rciNetNumber ', rciNetNumber);
      return true;
    }
    if (brand === 'RCI' && !(netNumber >= 20000 && netNumber <= 29999)) {
      return true;
    }
    if (brand === 'NIS' && !(netNumber >= 80000 && netNumber <= 89999)) {
      return true;
    }
    if ((brand === 'REN' || brand === 'DAC') && !(netNumber >= 0 && netNumber <= 9999)) {
      return true;
    }
    return false;
  }

  isReturnUrlValid(returnUrl: string): boolean {
    return CalculatorIndexComponent.isUrlEmpty(returnUrl) || CalculatorIndexComponent.isURLValid(returnUrl);
  }

  isReturnNegativeValid(returnUrl: string): boolean {
    return this.isYesNo(returnUrl) || CalculatorIndexComponent.isURLValid(returnUrl);
  }

  private static isUrlEmpty(theUrl: string): boolean {
    return (theUrl == null || theUrl.trim() === '');
  }

  private isYesNo(theUrl: string): boolean {
    return CalculatorIndexComponent.isUrlEmpty(theUrl) || theUrl.trim().toLowerCase() === 'yes' || theUrl.trim().toLowerCase() === 'no';
  }

  private static isURLValid(theUrl: string): boolean {
    return ((theUrl.toLowerCase().startsWith('http://') || theUrl.toLowerCase().startsWith('https://')) && theUrl.length <= 2000);
  }

  isProposalTypeInvalid(proposalType) {
    let validProposalTypes = ['online', 'budget', 'choice', 'none'];
    return !proposalType || validProposalTypes.indexOf(proposalType) === -1;
  }

  getPlaceholderPrepaymentPrice() {
    if (!this.model.view.vehiclePrice) {
      return 'FZG-Preis fehlt';
    } else if (!this.model.settings.prepaymentPrice) {
      return '' + this.model.settings.minPrepaymentPrice +
        '-' + this.model.settings.maxPrepaymentPrice;
    }
  }

  getPlaceholderVehiclePrice() {
    if (this.model.settings && this.model.settings.vehicle && this.model.settings.minVehiclePrice && this.model.settings.maxVehiclePrice) {
      return this.model.settings.minVehiclePrice + '-' + this.model.settings.maxVehiclePrice;
    }
    return '-';
  }

  checkRequiredParams(result) {
    if (!this.validateBaseRequiredParams(result)) {
      this.rciApi.sendParamMismatchEmail(result);
      this.themeService.setThemeByBrandCode(result.styleBrand, 'skyscraper');
      if (!this.isNetnumberValid(result.rciNetnumber, result.brandStyle)) {
        this.model.view.errortext = 'Netznummer passt nicht zur gewählten Marke';
      } else {
        this.model.view.errortext = 'Der Kalkulator steht Ihnen leider im Moment nicht zur Verfügung';
      }
      this.model.view.showPlaceholder = false;
      this.paramInvalid = true;
    } else {
      this.paramInvalid = false;
    }
  }

  private isNetnumberValid(netnumber: string, brand: string) {
    let number = parseInt(netnumber);
    if ("REN" == brand && number >= 0 && number <= 9999) {
      return true;
    } else if ("RCI" == brand && number >= 20000 && number <= 29999) {
      return true;
    } else if ("NIS" == brand && number >= 80000 && number <= 89999) {
      return true;
    }
    return false;
  }

  validateBaseRequiredParams(params) {
    if (this.isDealerEmailInvalid(params.dealerEmail)) {
      params.errorValidationText = 'isDealerEmailInvalid: ' + params.dealerEmail;
      return false;
    }
    if (!params.dealerName) {
      params.errorValidationText = 'Not dealerName: ' + params.dealerName;
      return false;
    }
    if (this.isBrandInvalid(params.brand)) {
      params.errorValidationText = 'isBrandInvalid: ' + params.brand;
      return false;
    }
    if (this.isBrandInvalidForDealer(params.brand, params.rciNetNumber)) {
      params.errorValidationText = 'isBrandInvalidForDealer: ' + params.brand + '_' + params.rciNetNumber;
      return false;
    }
    if (this.isProposalTypeInvalid(params.proposalType)) {
      params.errorValidationText = 'isProposalTypeInvalid: ' + params.proposalType;
      return false;
    }
    if (!this.isReturnUrlValid((params.returnUrl))) {
      params.errorValidationText = 'isReturnUrlInvalid: ' + params.returnUrl;
      return false;
    }
    if (!this.isReturnNegativeValid((params.returnNegative))) {
      params.errorValidationText = 'isReturnNegativeInvalid: ' + params.returnNegative;
      return false;
    }
    return true;
  }

  amendVehiclePrice(result) {
    let taxFactor = (1.0 + (environment.taxRate / 100));

    if (Number(result.priceType) !== 1) {
      if (result.vehiclePrice) {
        result.vehiclePrice = result.vehiclePrice * taxFactor;
      }
      if (result.optionPrice) {
        result.optionPrice = result.optionPrice * taxFactor;
      }
      if (result.accessoriesPrice) {
        result.accessoriesPrice = result.accessoriesPrice * taxFactor;
      }
      if (result.transportPrice) {
        result.transportPrice = result.transportPrice * taxFactor;
      }
      if (result.retailPrice) {
        result.retailPrice = result.retailPrice * taxFactor;
      }
    }
  }

  isShowSolvencyButton(rciNetNumber, dealerEmail, proposalType, validDealer) {
    return rciNetNumber && dealerEmail && validDealer && !this.isProposalTypeInvalid(proposalType) && 'none' != proposalType;
  }

  getEmailByRciNetNumber(result) {
    this.rciApi.getDealerEmail(result.rciNetNumber)
      .subscribe((data) => {
          console.log('received as dealer email : ' + data);
          result.dealerEmail = data;
          this.checkRequiredParams(result);
          if (this.isShowSolvencyButton(result.rciNetNumber, result.dealerEmail, result.proposalType, result.validDealer)) {
            this.model.view.showSolvency = true;
            this.model.view.callingSystem = this.conditionParams.callingSystem;
          }
        },
        (err) => {
          console.info('error at getEmailByRciNetNumber', err.data);
          this.checkRequiredParams(result);
        }
      );
  }

  getAddressByRciNetNumber(result): Observable<any> {
    return this.rciApi.getDealerAddress(result.rciNetNumber, result.dealerName).pipe(map((data: any) => {
        console.log('received as dealer address : ' + data);
        result.dealerAddressStreet = data.dealerAddressStreet;
        result.dealerAddressTown = data.dealerAddressTown;
        result.dealerAddressZip = data.dealerAddressZip;
        if (result.dealerName == null) {
          result.dealerName = data.dealerName;
        }
        result.dealerCode = data.dealerCode;
        result.dealerBrand = data.dealerBrand;
        result.validDealer = true;
        return result;
      },
      (error) => {
        console.info('error at getAddressByRciNetNumber', error.error);
        result.validDealer = false;
        return result;
      }));

  }

  readBrandParam(brand) {
    brand = brand || 'RCI';
    brand = brand.toUpperCase();
    if (brand !== 'RCI'
      && brand !== 'REN'
      && brand !== 'NIS'
      && brand !== 'DAC') {
      brand = 'RCI';
    }
    return brand;
  }

  checkVehicleNumber(vehicleNumber) {
    if (vehicleNumber.length == 0) {
      return vehicleNumber;
    }

    if (vehicleNumber.length != 17) {
      console.log('Invalid vehicle number length', vehicleNumber);
      return '';
    }
    vehicleNumber = vehicleNumber.toUpperCase();
    let s = vehicleNumber.slice(vehicleNumber.length - 4);
    if (!s.match(/^[0-9]+$/)) {
      console.log('Invalid vehicle number: not ended with 4 digits', vehicleNumber);
      return '';
    } else if (!vehicleNumber.match(/^[0-9ABCDEFGHJKLMNPRSTUVWXYZ]+$/)) {
      console.log('Invalid vehicle number: not allowed chars', vehicleNumber);
      return '';
    }

    return vehicleNumber;
  }

  validateInterestRatePercent(result) {
    if (!result.interestRatePercent) {
      return;
    }
    if (!Number.isNaN(result.interestRatePercent) && result.interestRatePercent >= 0 && result.interestRatePercent <= 99.99) {
      result.interestRatePercent = Number(result.interestRatePercent).toFixed(2);
      return;
    }
    result.interestRatePercent = '';
  }

  validateVehicleType(vehicleType) {
    if (vehicleType) {
      if (['N', 'G', 'V'].includes(vehicleType.toUpperCase())) {
        return true;
      }
    }
    return false;
  }

  mapParams() {
    this.activatedRoute.queryParams.subscribe(params => {
        let result: any = {};
        let brand = params.brand;
        result.offerCode = params.id;
        result.styleBrand = this.readBrandParam(brand);
        if (result.styleBrand === 'DAC') {
          result.brand = 'REN';
        } else {
          result.brand = result.styleBrand;
          result.returnUrl = this.checkUndefined(params.returnUrl, null);
          result.returnNegative = this.checkUndefined(params.returnNegative, null);
        }
        result.pdfBrand = result.styleBrand;
        result.rciNetNumber = params.rciNetNumber;
        result.dealerName = params.dealerName;
        result.dealerEmail = params.dealerEmail;
        result.dealerEmailInUrl = !!params.dealerEmail;
        result.makeCode = this.checkUndefined(params.makeCode, '');
        result.makeDescription = this.checkUndefined(params.makeDescription, '');
        result.modelCode = this.checkUndefined(params.modelCode, '');
        result.modelDescription = this.checkUndefined(params.modelDescription, '');
        result.versionCode = this.checkUndefined(params.versionCode, '');
        result.versionDescription = this.checkUndefined(params.versionDescription, '');
        result.engineType = this.checkUndefined(params.engineType, '');

        if (this.validateVehicleType(params.vehicleType)) {
          result.vehicleType = params.vehicleType;
          result.interestRatePercent = params.interestRatePercent === '' ? null : params.interestRatePercent;
        } else {
          result.vehicleType = 'G';
          result.interestRatePercent = null;
        }

        result.priceType = params.priceType;
        result.vehiclePrice = params.vehiclePrice;
        result.retailPrice = this.checkUndefined(params.retailPrice, '');
        result.hsn = this.checkUndefined(params.hsn, '');
        result.tsn = this.checkUndefined(params.tsn, '');
        result.purchaseBattery = this.checkUndefined(params.purchaseBattery, false);
        result.callingSystem = params.callingSystem;
        result.fuelType = this.checkUndefined(params.fuelType, '');
        result.phase = this.checkUndefined(params.phase, '');
        result.firstRegistrationDate = this.checkUndefined(params.firstRegistrationDate, '');
        result.currentMileage = this.checkUndefined(params.currentMileage, 0);
        result.proposalType = (params.proposalType ? params.proposalType : 'budget');
        result.optionPrice = 0;
        result.transportPrice = 0;
        if (result.vehicleType !== 'G') {
          result.optionPrice = this.checkUndefined(params.optionPrice, 0);
          result.transportPrice = this.checkUndefined(params.transportPrice, 0);
        }
        result.accessoriesPrice = this.checkUndefined(params.accessoriesPrice, 0);

        if (result.retailPrice === '') {
          result.retailPrice = parseInt(result.vehiclePrice) + parseInt(result.optionPrice) + parseInt(result.transportPrice);
        }

        result.residualValueModification = this.checkUndefined(params.residualValueModification, 0);

        result.preselectMileage = this.checkUndefined(params.preselectMileage, 0);
        result.preselectDuration = this.checkUndefined(params.preselectDuration, 0);
        result.preselectContractKind = this.checkUndefined(params.preselectContractKind, '');
        result.preselectDownpayment = this.checkUndefinedOrEmpty(params.preselectDownpayment, '0');
        result.usedCarTaxType = this.checkUndefined(params.usedCarTaxType, 'difference');

        result.contractkind = this.checkUndefined(params.contractkind, null);
        result.contactdealer = this.checkUndefined(params.contactdealer, null);

        result.freeText = this.checkUndefined(params.freeText, '');
        if (result.freeText.length > environment.maxLengthFreeText) {
          result.freeText = result.freeText.substr(0, environment.maxLengthFreeText);
        }
        result.vehicleNumber = this.checkVehicleNumber(this.checkUndefined(params.vehicleNumber, ''));

        result.parentUrl = (window.location !== window.parent.location) ? document.referrer : document.location.href;

        if (result.dealerEmail) {
          this.checkRequiredParams(result);
        } else {
          if (result.rciNetNumber) {
            this.getEmailByRciNetNumber(result);
          } else {
            this.checkRequiredParams(result);
          }
        }

        if (result.interestRatePercent) {
          this.validateInterestRatePercent(result);
        }
        this.amendVehiclePrice(result);

        if (!this.paramInvalid) {
          this.getAddressByRciNetNumber(result).subscribe(data => {
              if (this.isShowSolvencyButton(data.rciNetNumber, data.dealerEmail, data.proposalType, data.validDealer)) {
                this.model.view.showSolvency = true;
                this.model.view.callingSystem = data.callingSystem;
              }
              this.getConditions(result);
              this.conditionParams = result;
            },
            (error) => {
              console.info('error at getAddressByRciNetNumber', error.error);
              result.validDealer = false;
              this.setError(result.styleBrand);
              this.conditionParams = result;
              return result;
            });
        }
        // return result;
      }
    );
  }

  readBrandAndSetTheme() {
    this.activatedRoute.queryParams.subscribe(params => {
      let brand = params.brand;
      this.model.view.brand = this.readBrandParam(brand);
      this.themeService.setThemeByBrandCode(this.model.view.brand, 'skyscraper');
    });
  }

  checkUndefined(theVariable, theDefault) {
    if (typeof theVariable === 'undefined' || null === theVariable) {
      return theDefault;
    }
    return theVariable;
  }
  checkUndefinedOrEmpty(theVariable, theDefault) {
    if (typeof theVariable === 'undefined' || null === theVariable) {
      return theDefault;
    }
    if (theVariable === '') {
      return theDefault;
    }
    return theVariable;
  }

  setCorrectBrand(conditionParams) {
    if (conditionParams.dealerBrand === conditionParams.brand) {
      console.log('Brand param and dealer brand are the same');
      return;
    }
    if (conditionParams.brand === 'RCI') {
      console.log('Dealer with brand ' + conditionParams.dealerBrand + ' want to use RCI layout, but have to use ' + conditionParams.dealerBrand + ' conditions');
      conditionParams.brand = conditionParams.dealerBrand;
      return;
    }
    console.log('Dealer with brand ' + conditionParams.dealerBrand + ' want to use ' + conditionParams.brand + ' layout');
  }

  getContractKindCodeForPreselectedContractKind(preselectedCode, defaultCode) {
    let kindCode = defaultCode;
    let availableCodes = [['V', '1'], ['2W', '2'], ['3W', '10'], ['L', '11']];

    let kindCodes = availableCodes.map((item) => {
      return item[0];
    });

    let index = kindCodes.indexOf(preselectedCode);
    if (index >= 0) {
      kindCode = availableCodes[index][1];
    }

    return kindCode;
  }

  getConditions(conditionParams) {
    return this.rciApi.getConditions(conditionParams)
      .subscribe((data) => {
          let defaultContractKindCode;
          this.model.view.errortext = undefined;

          this.themeService.setThemeByBrandCode(conditionParams.styleBrand, 'skyscraper');
          // this.themeService.setThemeByBrandCode(data.header.brand, 'skyscraper');
          this.conditionsResponse = data;

          if (data.conditions == null || data.conditions.length == 0) {
            this.setError(conditionParams.styleBrand);
            return;
          }

          if (!data.vehicle.vehiclePrice || data.vehicle.vehiclePrice < data.defaults.minVehiclePrice) {
            this.model.view.showPlaceholder = false;
            this.model.view.showContactYourDealer = true;
          } else {
            this.model.view.showContactYourDealer = false;
          }

          this.model.settings = data.defaults;
          this.prepaymentPriceGetSet(data.defaults.prepaymentPrice);
          // this.model.settings.prepaymentPrice = this.convertFloat(data.defaults.prepaymentPrice);
          this.model.settings.parentUrl = conditionParams.parentUrl;
          this.replaceDefaultContractKind(this.model.settings, data.conditions, conditionParams.contractkind);
          this.model.view.brand = conditionParams.styleBrand;
          // this.model.view.brand = data.header.brand;
          this.model.view.brandFull = this.model.view.brand === 'REN' ? 'Renault' : 'NISSAN';
          this.model.view.showContactDealer = (conditionParams.contactdealer !== 'nc');
          this.model.view.dealerName = conditionParams.dealerName;

          this.model.view.vehiclePriceDefault = data.vehiclePriceDefault;
          this.model.view.vehiclePrice = data.vehicle.vehiclePrice || data.vehiclePriceDefault;
          this.model.view.retailPrice = data.vehicle.retailPrice || data.vehiclePrice;
          this.model.view.accessoriesPrice = data.vehicle.accessoriesPrice || 0;
          this.model.view.optionPrice = data.vehicle.optionPrice || 0;
          this.model.view.transportPrice = data.vehicle.transportPrice || 0;
          this.model.view.vehicleName = data.vehicle.model;
          this.model.view.conditions = data.conditions;

          this.model.view.vehicleType = conditionParams.vehicleType || 'G';
          this.model.view.totalVehiclePrice = this.getVehicleTotalPrice(this.model.view.vehicleType, this.model.view.vehiclePrice, this.model.view.accessoriesPrice, this.model.view.optionPrice, this.model.view.transportPrice);

          this.vehicle = data.vehicle;

          if (conditionParams.contractkind) {
            defaultContractKindCode = conditionParams.contractkind;
          } else {
            defaultContractKindCode = this.getContractKindCodeForPreselectedContractKind(conditionParams.preselectContractKind, data.defaultContractKindCode);
          }

          if (this.isPositiveNumber(conditionParams.preselectDownpayment)) {
            this.model.settings.prepaymentPriceDefault = conditionParams.preselectDownpayment;
            this.model.settings.prepaymentPrice = this.model.settings.prepaymentPriceDefault;
            this.prepaymentPriceGetSet(conditionParams.preselectDownpayment);
          }

          this.setContractKind(this.model.view.conditions.filter((cond) => cond.contractKindCode === defaultContractKindCode) [0]);

          if (!this.model.settings.contractKind) {
            this.setContractKind(this.model.view.conditions.filter((cond) => {
                return cond.contractKindCode === data.defaultContractKindCode;
              }
            )[0]);
          }

          if (!this.model.settings.contractKind) {
            this.setContractKind( this.model.view.conditions[0]);
          }

          if (this.model.settings.contractKind) {
            console.log('if (this.model.settings.contractKind) {', this.contractKind(), this.model.settings.contractKind, this.tooltipContentInfo())
            let index;
            let newDefaultDuration = this.model.settings.contractKind.defaultDuration;
            let newDefaultMileage = this.model.settings.mileage;

            if (conditionParams.preselectDuration) {
              let durations = this.model.settings.contractKind.durations.map((theDuration) => {
                return theDuration.duration;
              });
              if (durations.indexOf(Number(conditionParams.preselectDuration)) >= 0) {
                newDefaultDuration = Number(conditionParams.preselectDuration);
              }
            }
            this.model.settings.duration = newDefaultDuration;

            if (conditionParams.preselectMileage) {
              index = this.model.settings.contractKind.mileageValues.indexOf(Number(conditionParams.preselectMileage));
              if (index >= 0) {
                newDefaultMileage = Number(conditionParams.preselectMileage);
              }
            }
            this.model.settings.mileage = newDefaultMileage;
          }

          if (this.cookieService.cookieAsked && !this.paramInvalid && !this.model.view.showContactYourDealer) {
            this.calculateRate();
          } else {
            console.log('no price -> no calc');
          }
        }
        ,
        (error) => {
          // if (error.data.messages[0] === 'NO_CONDITION') {
          //     this.model.view.errortext = 'Der Kalkulator steht Ihnen leider im Moment nicht zur Verfügung';
          // }
          this.setError(conditionParams.styleBrand);
          console.log(error);
        }
      )
      ;
  }

  setError(styleBrand: string) {
    this.themeService.setThemeByBrandCode(styleBrand, 'skyscraper');
    this.model.view.errortext = 'Der Kalkulator steht Ihnen leider im Moment nicht zur Verfügung';
    this.model.view.showPlaceholder = false;
    this.model.setEmptySettings();
    this.model.view.currentResult = undefined;
    this.disableCalculating();
  }

  getSliderConfig() {
    let values = [];
    let sliderElementMin: number;
    let sliderElementMax: number;
    if (this.model.settings && this.model.settings.contractKind && this.model.settings.contractKind.mileageValues) {
      values = this.model.settings.contractKind.mileageValues;
      sliderElementMin = Math.min(...this.model.settings.contractKind.mileageValues);
      sliderElementMax = Math.max(...this.model.settings.contractKind.mileageValues);
    }

    let mileageSliderConfig: any = {
      behaviour: 'tap-drag',
      connect: true,
      orientation: 'horizontal',
      tooltips: true,
      pips: {
        mode: 'values',
        stepped: true,
        values: values,
        density: 100
      },
      range: {
        'min': sliderElementMin,
        'max': sliderElementMax
      },
      format: {
        to: function (value) {
          return String(parseFloat(parseFloat(String(value)).toFixed(2)));
        },
        from: function (value) {
          return parseFloat(value);
        }
      }
    };
    return mileageSliderConfig;
  }

  isPositiveNumber(value) {
    let parsedValue;
    if (!value) {
      return false;
    }
    if (value === '') {
      return false;
    }

    if (!value.match(/^\d+$/)) {
      return false;
    }

    parsedValue = parseInt(value);

    return !isNaN(parsedValue);
  }

  getVehicleTotalPrice(vehicleType, vehiclePrice, accessoriesPrice, optionPrice, transportPrice) {
    if (vehicleType !== 'G') {
      return vehiclePrice + accessoriesPrice + optionPrice + transportPrice;
    }
    return vehiclePrice + accessoriesPrice;
  }

  prepaymentPriceGetSetEvent(event) {
    this.prepaymentPriceGetSet(event.value);
  }

  prepaymentPriceGetSet(prepaymentPrice) {
    if (arguments.length > 0) {
      if (this.model.settings) {
        prepaymentPrice = this.parseFloatDe(prepaymentPrice);
        if (prepaymentPrice < this.model.settings.minPrepaymentPrice
          || prepaymentPrice > this.model.settings.maxPrepaymentPrice) {
          // this.model.settings.prepaymentPrice = null;
          // this.resetResult();
          this.model.settings.prepaymentPrice = this.model.settings.prepaymentPriceDefault;
        } else {
          this.model.settings.prepaymentPrice = this.convertFloat(prepaymentPrice);
        }
      }
    } else {
      if (this.model.settings) {
        return this.model.settings.prepaymentPrice;
      }
      return null;
    }
  }

  adjustPrepaymentLimits(oldVehiclePrice) {
    let minPrepaymentAmount = environment.minPrepayment;
    if (this.conditionParams.styleBrand !== 'DAC') {
      minPrepaymentAmount = 0;
    }
    if (this.model.view.vehiclePrice) {
      this.conditionsResponse.minPrepaymentPrice = Math.round(this.model.view.vehiclePrice * this.conditionsResponse.prepaymentPercentMin) | minPrepaymentAmount;
      this.conditionsResponse.maxPrepaymentPrice = Math.round(this.model.view.vehiclePrice * this.conditionsResponse.prepaymentPercentMax);
      if (!this.model.settings.prepaymentPrice) {
        this.model.settings.prepaymentPrice = this.model.view.vehiclePrice * this.model.settings.prepaymentPercentDefault;
        this.model.settings.prepaymentPrice = this.convertFloat(this.model.settings.prepaymentPrice);
      } else {
        let prepayment = this.parseFloatDe(this.model.settings.prepaymentPrice);
        if (prepayment > this.conditionsResponse.maxPrepaymentPrice) {
          prepayment = (prepayment / oldVehiclePrice) * this.model.view.vehiclePrice;
          this.model.settings.prepaymentPrice = this.convertFloat(prepayment);
        }
      }
    }
  }

  vehiclePriceGetSetEvent(event) {
    this.vehiclePriceGetSet(event.value);
  }

  vehiclePriceGetSet(value) {
    let oldVehiclePrice;
    if (arguments.length > 0) {
      if (this.model.settings) {
        value = this.parseFloatDe(value);
        if (!value || value < this.model.settings.minVehiclePrice || value > this.model.settings.maxVehiclePrice) {
          this.model.view.vehiclePrice = null;
          this.prepaymentPriceGetSet(null);
          this.resetResult();
        } else {
          oldVehiclePrice = this.parseFloatDe(this.model.view.vehiclePrice);
          this.model.view.vehiclePrice = value;
          this.conditionsResponse.vehicle.vehiclePrice = value;
          this.adjustPrepaymentLimits(oldVehiclePrice || this.model.view.vehiclePriceDefault);
        }
      }
    } else {
      return this.model.view.vehiclePrice;
    }
  }

  replaceDefaultContractKind(settings, conditions, contractkind) {
    let i;
    let condition;

    if (!contractkind) {
      return;
    }

    for (i = 0; i < conditions.length; i++) {
      condition = conditions[i];
      if (condition.contractKindCode === contractkind) {
        settings.contractKind = condition;
        break;
      }
    }
  }

  rangeChanged() {
    this.calculateRate();
    // this.lastRangeChange = new Date().getTime();
    //
    // setTimeout(() {
    //     calculateRateDelayed();
    // }, delay);
  }

  // calculateRateDelayed() {
  //   let now = new Date().getTime();
  //   if (this.lastRangeChange + delay < now) {
  //     this.calculateRate();
  //   }
  // }

  enableCalculating() {
    // if ($scope) {
    this.calculating = true;
    // }
  }

  disableCalculating() {
    // if ($scope) {
    this.calculating = false;
    // this.calculating = true;
    // }
  }

  logError(error) {
    console.log('Error caught: ', error);
    this.disableCalculating();
  }

  changeContractKind(contractKindObj) {
    if (!this.model.settings.duration) {
      this.model.settings.duration = contractKindObj.defaultDuration;
    }
    if (contractKindObj.durationsValues.indexOf(this.model.settings.duration) === -1) {
      this.model.settings.duration = contractKindObj.durationsValues.slice(-1)[0];
    }
    if ((this.model.settings.prepaymentPrice || this.model.settings.prepaymentPrice === 0) && this.model.view.vehiclePrice) {
      this.calculateRate();
    }
  }

  resetResult() {
    this.model.view.currentResult = undefined;
    this.model.view.showInvalidCondition = false;
  }

  getConditionCode(durations, settings) {
    let conditionCode = durations.filter((durationObj) => {
        return durationObj.duration === settings.duration
          && ((durationObj.gap === null) ? true : durationObj.gap === settings.gap)
          && ((durationObj.residualInsurance === null) ? true : durationObj.residualInsurance === settings.rsv);
      }
    )
      [0];

    return conditionCode && conditionCode.conditionCode;
  }

  isLeasing() {
    if (this.model.settings && this.model.settings.contractKind && this.model.settings.contractKind.calculationTypeCode) {
      return this.model.settings.contractKind.calculationTypeCode === 'L';
    }
    return false;
  }

  isFinancing() {
    if (this.model.settings && this.model.settings.contractKind && this.model.settings.contractKind.calculationTypeCode) {
      return this.model.settings.contractKind.calculationTypeCode === 'F';
    }
    return false;
  }

  toGross(price) {
    return price * (100 + environment.taxRate) / 100.0;
  }

  toNet(price) {
    return price / (100 + environment.taxRate) * 100.0;
  }

  calculateTotalMileage(durationInMonths, yearlyMileage) {
    return (durationInMonths / 12) * yearlyMileage;
  }

  postCalculation() {
    let calculation: any = {};
    let prepaymentPrice = this.parseFloatDe(this.model.settings.prepaymentPrice);

    calculation.rate = this.model.view.currentResult.rate;
    calculation.residualValuePrice = this.model.view.currentResult.residualValuePrice;
    calculation.residualValuePercent = this.model.view.currentResult.residualValuePercent;
    calculation.totalRatePrice = this.model.view.currentResult.totalRatePrice;
    calculation.prepaymentPrice = prepaymentPrice;
    calculation.duration = this.model.settings.duration;
    calculation.mileage = this.model.settings.mileage;
    calculation.contractKind = this.model.settings.contractKind.contractKindDescription.trim();

    calculation.pangv = {};
    calculation.pangv.fahrzeugpreis = (this.model.view.totalVehiclePrice).toFixed(2);
    calculation.pangv.anzahlung = (prepaymentPrice).toFixed(2);
    calculation.pangv.nettodarlehnsbetrag = (this.model.view.totalVehiclePrice - calculation.prepaymentPrice).toFixed(2);
    calculation.pangv.laufzeit = this.model.settings.duration;
    calculation.pangv.monatsrate = (this.model.view.currentResult.rate).toFixed(2);
    calculation.pangv.schlussrate = (this.model.view.currentResult.residualValuePrice).toFixed(2);
    calculation.pangv.gesamtkilometerleistung = this.calculateTotalMileage(this.model.settings.duration, this.model.settings.mileage);
    calculation.pangv.gesamtbetrag = (calculation.totalRatePrice).toFixed(2);
    calculation.pangv.gesamtzahlungen = (calculation.totalRatePrice + calculation.prepaymentPrice).toFixed(2);
    calculation.pangv.effektivzins = (this.model.view.currentResult.effectiveInterestPercent).toFixed(2);
    calculation.pangv.sollzins = (this.model.view.currentResult.nominalInterestPercent).toFixed(2);
    calculation.pangv.hinweis = 'Angaben stellen zugleich ein repr&auml;sentatives Beispiel gem. § 6a Abs. 4 PAngV dar.';

    window.parent.postMessage(calculation, '*');
  }

  getTotalLoanAmount() {
    if (this.model.view.totalVehiclePrice && this.model.settings.prepaymentPrice) {
      return this.model.view.totalVehiclePrice - this.parseFloatDe(this.model.settings.prepaymentPrice);
    }
    return;
  }

  calculateLeasingRate(vehicle) {
    let options = {
      header: this.conditionsResponse.header,
      vehicle: vehicle,
      vehiclePrice: vehicle.vehiclePrice,
      otherCostsPrice: 0,
      prepaymentPrice: this.toNet(this.parseFloatDe(this.model.settings.prepaymentPrice)),
      duration: this.model.settings.duration,
      conditionCode: this.model.settings.conditionCode,
      mileage: this.model.settings.mileage,
      residualInsurance: this.model.settings.rsv,
      gap: this.model.settings.gap,
      customerAge: this.ageCalculation.ageFromBirthYear(this.model.view.birthYear),
      fuelType: this.conditionParams.fuelType,
      engineType: this.conditionParams.engineType,
      purchaseBattery: this.conditionParams.purchaseBattery,
      phase: this.conditionParams.phase,
      firstRegistrationDate: this.conditionParams.firstRegistrationDate,
      currentMileage: this.conditionParams.currentMileage,
      proposalType: this.conditionParams.proposalType,
      residualValueModification: this.conditionParams.residualValueModification
    };

    options.vehicle.vehiclePrice = this.toNet(options.vehicle.vehiclePrice || this.model.view.vehiclePrice);
    options.vehiclePrice = options.vehicle.vehiclePrice;

    options.vehicle.retailPrice = this.toNet(options.vehicle.retailPrice || this.model.view.retailPrice);

    // Prices should be net values for leasing
    options.vehicle.accessoriesPrice = this.toNet(options.vehicle.accessoriesPrice || 0);
    options.vehicle.optionPrice = this.toNet(options.vehicle.optionPrice || 0);
    options.vehicle.transportPrice = this.toNet(options.vehicle.transportPrice || 0);

    // this.trackGoogleAnalytics('calculator', 'calculate');

    console.debug('Leasing Request Array', options);
    this.rciApi.getLeasing(options).subscribe((result) => {
        console.debug('leasing result net', result);
        this.model.view.errortext = undefined;

        this.model.view.currentResult = result;
        this.model.view.currentResult.rate = this.model.view.currentResult.rateGross;
        this.model.settings.maxPrepaymentPrice = Math.round(this.toGross(this.model.view.currentResult.downpaymentMax));
        this.prepaymentPriceGetSet(this.toGross(this.model.view.currentResult.downpaymentUsed));

        this.model.view.currentResult.rateGap = this.toGross(this.model.view.currentResult.rateGap);
        this.model.view.currentResult.rateRsv = this.toGross(this.model.view.currentResult.rateRsv);
        this.model.view.currentResult.residualValuePrice = this.toGross(this.model.view.currentResult.residualValuePrice);
        this.model.view.currentResult.totalRatePrice = this.toGross(this.model.view.currentResult.totalRatePrice);

        console.debug('leasing result gross', this.model.view.currentResult);

        // window.GTMParameters = {
        //   view: this.model.view,
        //   settings: this.model.settings,
        //   conditionsResponse: this.conditionsResponse
        // };
        this.postCalculation();
        this.disableCalculating();
      }
      ,
      (error) => {
        if (error.error.messages == null && error.error.message) {
          error.error.messages = [error.error.message];
        }
        this.model.view.errortext = this.getErrorTextToDisplay(error.error.messages);
        this.logError(error);
        this.resetResult();
      }
    );
  }

  public parseFloatDe(number) {
    if (typeof number === 'string' || number instanceof String) {
      number = number.replace('.', '').replace(',', '.');
    }
    return parseFloat(number);
  }

  private convertFloat(floatNumber) {
    return this.decimalPipe.transform(floatNumber, '1.2-2');
  }

  calculateFinanceRate(vehicle) {
    let options = {
      header: this.conditionsResponse.header,
      vehicle: vehicle,
      otherCostsPrice: 0,
      prepaymentPrice: this.parseFloatDe(this.model.settings.prepaymentPrice),
      duration: this.model.settings.duration,
      contractKindCode: this.model.settings.contractKind.contractKindCode,
      conditionCode: this.model.settings.conditionCode,
      mileage: this.model.settings.mileage,
      residualInsurance: this.model.settings.rsv,
      gap: this.model.settings.gap,
      customerAge: this.ageCalculation.ageFromBirthYear(this.model.view.birthYear),
      balloon: this.model.settings.contractKind.balloon,
      fuelType: this.conditionParams.fuelType,
      engineType: this.conditionParams.engineType,
      purchaseBattery: this.conditionParams.purchaseBattery,
      phase: this.conditionParams.phase,
      firstRegistrationDate: this.conditionParams.firstRegistrationDate,
      currentMileage: this.conditionParams.currentMileage,
      proposalType: this.conditionParams.proposalType,
      residualValueModification: this.conditionParams.residualValueModification
    };

    options.vehicle.vehiclePrice = options.vehicle.vehiclePrice || this.model.view.vehiclePrice;
    options.vehicle.retailPrice = options.vehicle.retailPrice || this.model.view.retailPrice;

    //this.trackGoogleAnalytics('calculator', 'calculate');

    console.debug('Finance Request Array', options);
    this.rciApi.getFinance(options).subscribe((result) => {
        console.debug(result);
        this.model.view.errortext = undefined;
        this.model.view.currentResult = result;
        this.model.settings.maxPrepaymentPrice = Math.round(this.model.view.currentResult.downpaymentMax);
        this.prepaymentPriceGetSet(this.model.view.currentResult.downpaymentUsed);

        // window.GTMParameters = {
        //   view: this.model.view,
        //   settings: this.model.settings,
        //   conditionsResponse: this.conditionsResponse
        // };
        this.postCalculation();
        this.disableCalculating();
      }
      ,
      (error) => {
        if (error.error.messages == null && error.error.message) {
          error.error.messages = [error.error.message];
        }
        this.model.view.errortext = this.getErrorTextToDisplay(error.error.messages);
        this.logError(error);
        this.resetResult();
      }
    );
  }

  getErrorTextToDisplay(messages) {
    let errortext: string;

    if (messages[0] === 'NO_FINANCE' || messages[0] === 'NO_LEASING') {
      errortext = 'Der Kalkulator steht Ihnen leider im Moment nicht zur Verfügung';
    } else if (messages[0] === 'Rate is below minimum allowed rate.') {
      errortext = 'Die Mindestrate für Finanzierung oder Leasing ist unterschritten. Bitte passen Sie Ihre Angaben an.';
    } else {
      let b1 = messages.indexOf('Option price is below zero.');
      let b2 = messages.indexOf('Accessories price is below zero.');
      let b3 = messages.indexOf('Transport price is below zero.');

      if (b1 === -1 && b2 === -1 && b3 === -1) {
        errortext = 'Für die angegebenen Daten kann keine Rate berechnet werden. Bitte passen Sie Ihre Angaben an.';
      } else {
        errortext = 'Für die angegebenen Daten kann keine Rate berechnet werden. Bitte wenden Sie sich an Ihren Händler.';
      }
    }

    return errortext;
  }

  calculateRate() {
    let vehicle;

    if (this.model.settings && !this.model.settings.contractKind) {
      this.model.view.errortext = 'Der Kalkulator steht Ihnen leider im Moment nicht zur Verfügung';
      this.model.view.currentResult = undefined;
      this.disableCalculating();
      return;
    }

    if (!this.model.view.vehiclePrice || (!this.model.settings.prepaymentPrice && !(this.model.settings.prepaymentPrice === 0))) {
      this.model.view.errortext = 'Für die angegebenen Daten kann keine Rate berechnet werden. Bitte passen Sie Ihre Angaben an.';
      this.model.view.currentResult = undefined;
      this.disableCalculating();
      return;
    }

    this.model.settings.conditionCode = this.getConditionCode(this.model.settings.contractKind.durations, this.model.settings);
    this.enableCalculating();

    this.model.view.showInvalidCondition = !this.model.settings.conditionCode;

    if (this.conditionsResponse.vehicle) {
      vehicle = this.clone(this.conditionsResponse.vehicle);
    } else {
      vehicle = {};
    }


    if (this.isLeasing()) {
      this.calculateLeasingRate(vehicle);
    } else if (this.isFinancing()) {
      this.calculateFinanceRate(vehicle);
    }
  }

  clone(obj) {
    let copy;
    if (null == obj || 'object' != typeof obj) {
      return obj;
    }

    copy = obj.constructor();

    for (let attr in obj) {
      if (obj.hasOwnProperty(attr)) {
        copy[attr] = obj[attr];
      }
    }

    return copy;
  }

  printPdf() {
    if (!this.model.view.currentResult) {
      return;
    }

    let totalPrice = this.getVehicleTotalPrice(this.model.view.vehicleType,
      (this.conditionsResponse.vehicle.vehiclePrice || this.model.view.vehiclePrice),
      (this.conditionsResponse.vehicle.accessoriesPrice || this.model.view.accessoriesPrice),
      (this.conditionsResponse.vehicle.optionPrice || this.model.view.optionPrice),
      (this.conditionsResponse.vehicle.transportPrice || this.model.view.transportPrice));

    let options = {
      // brand: this.model.view.styleBrand,
      brand: this.conditionParams.pdfBrand,
      rciNetNumber: this.conditionParams.rciNetNumber,
      dealerName: this.conditionParams.dealerName ? this.conditionParams.dealerName : '',
      dealerEmail: this.conditionParams.dealerEmail ? this.conditionParams.dealerEmail : '',
      vin: this.conditionsResponse.vehicle.vin,
      contractKindCode: this.model.settings.contractKind.contractKindCode,
      salesChannelSource: this.conditionsResponse.salesChannel.source,
      salesChannelCode: this.conditionsResponse.salesChannel.code,
      vehicleMake: this.conditionsResponse.vehicle.make,
      vehicleModel: this.conditionsResponse.vehicle.model,
      vehicleDescription: this.conditionsResponse.vehicle.version,
      vehiclePrice: totalPrice || this.model.view.totalVehiclePrice,
      prepaymentPrice: this.parseFloatDe(this.model.settings.prepaymentPrice),
      gap: this.model.settings.gap ? this.model.view.currentResult.rateGap : null,
      rsv: this.model.settings.rsv ? this.model.view.currentResult.rateRsv : null,
      normalInterestPercent: this.model.view.currentResult.nominalInterestPercent,
      effectiveInterestPercent: this.model.view.currentResult.effectiveInterestPercent,
      sumOfRates: this.model.view.currentResult.totalRatePrice,
      mileage: this.model.settings.mileage,
      duration: this.model.settings.duration,
      residualValuePrice: this.model.view.currentResult.residualValuePrice,
      rate: this.model.view.currentResult.rate
    };

    // this.trackGoogleAnalytics('calculator', 'print');

    // mobileTracker.print($routeParams.contractkind, $routeParams.contactdealer, conditionsResponse.header.brand);

    console.debug('PDF Print Options', options);
    this.rciApi.printPdf(options);
  }

  encode(text) {
    return encodeURI(text).replace('&', '%26');
  }

  getVehicleDescription() {
    let result = [];

    if (this.conditionParams.makeDescription) {
      result.push(this.conditionParams.makeDescription);
    }

    if (this.conditionParams.modelDescription) {
      result.push(this.conditionParams.modelDescription);
    }

    if (this.conditionParams.versionDescription) {
      result.push(this.conditionParams.versionDescription);
    }

    if (result.length > 0) {
      return result.join(' ');
    }

    return null;
  }

  createpreacceptanceParameters(params) {
    return '/' + this.preAcceptancePath(this.conditionParams.proposalType) + '?callbackNr=' + params + '&brand=' + this.conditionParams.styleBrand;
  }

  preAcceptancePath(proposalType) {
    return environment.startpagepaths[proposalType] || '';
  }

  determineCallingSystem(callingSystem) {
    if (!callingSystem || this.validCallingSystems.indexOf(callingSystem) === -1) {
      return '03';
    }
    return callingSystem;
  }

  preAcceptance() {
    if (this.conditionParams.dealerCode == null || this.conditionParams.dealerCode == '') {
      this.rciApi.getDealerAddress(this.conditionParams.rciNetNumber, this.conditionParams.dealerName)
        .pipe(map((data: any) => {
            this.conditionParams.dealerCode = data.dealerCode;
            this.saveDataAndChangeToPreAcceptance();
          },
          (error) => {
            console.info('error at getAddressByRciNetNumber', error.error);
            this.saveDataAndChangeToPreAcceptance();
          }));
    } else {
      this.saveDataAndChangeToPreAcceptance();
    }
  }

  saveDataAndChangeToPreAcceptance() {
    if (!this.model.view.currentResult) {
      return;
    }
    let urlPath;
    let newTabWindow;
    if (this.conditionParams.proposalType !== 'online') {
      newTabWindow = window.open('', '_blank');
    }

    this.rciApi.saveData(this.createDecisionData())
      .subscribe((result) => {
          urlPath = this.createpreacceptanceParameters(result);
          if (this.conditionParams.proposalType !== 'online') {
            newTabWindow.location.href = environment.budgetcalcUrl + urlPath;
          } else {
            window.top.location.replace(environment.budgetcalcUrl + urlPath);
          }

        }
        ,
        (error => console.error(error))
      );
  }

  createDecisionData() {
    let customerData: any = {};
    customerData.rate = this.model.view.currentResult.rate;
    customerData.brand = this.conditionParams.brand;
    customerData.brandStyle = this.conditionParams.styleBrand;
    customerData.rciNetnumber = this.conditionParams.rciNetNumber;
    customerData.dealerEmail = this.conditionParams.dealerEmail;
    if (this.conditionParams.dealerCode == null || this.conditionParams.dealerCode == '') {
      this.rciApi.getDealerAddress(this.conditionParams.rciNetNumber, this.conditionParams.dealerName)
        .pipe(map((data: any) => {
            customerData.dealerCode = data.dealerCode;
          },
          (error) => {
            console.info('error at getAddressByRciNetNumber', error.error);
          }));
    } else {
      customerData.dealerCode = this.conditionParams.dealerCode;
    }
    customerData.returnUrl = this.conditionParams.returnUrl;
    customerData.returnNegative = this.conditionParams.returnNegative;

    customerData.dealerName = this.conditionParams.dealerName ? this.conditionParams.dealerName : '';
    let vehicleDescription = this.getVehicleDescription();
    if (vehicleDescription) {
      customerData.vehicleDescription = vehicleDescription;
    }

    let totalPrice = this.getVehicleTotalPrice(this.model.view.vehicleType,
      this.model.view.vehiclePrice,
      this.model.view.accessoriesPrice,
      this.model.view.optionPrice,
      this.model.view.transportPrice);

    customerData.vehiclePrice = this.model.view.vehiclePrice;
    customerData.retailPrice = this.model.view.retailPrice;
    customerData.optionPrice = this.model.view.optionPrice;
    customerData.accessoriesPrice = this.model.view.accessoriesPrice;
    customerData.transportPrice = this.model.view.transportPrice;
    customerData.vehicleType = this.model.view.vehicleType;
    customerData.makeCode = this.conditionParams.makeCode;
    customerData.modelCode = this.conditionParams.modelCode;
    customerData.tsn = this.conditionParams.tsn;
    customerData.hsn = this.conditionParams.hsn;
    customerData.prepayment = this.parseFloatDe(this.model.settings.prepaymentPrice);
    customerData.netloanamount = totalPrice - this.parseFloatDe(this.model.settings.prepaymentPrice);
    customerData.nominalInterestPercent = this.model.view.currentResult.nominalInterestPercent;
    customerData.effectiveInterestPercent = this.model.view.currentResult.effectiveInterestPercent;
    customerData.totalRatePrice = this.model.view.currentResult.totalRatePrice;
    customerData.duration = this.model.settings.duration;

    let mileageParam = '';
    if (this.model.settings.contractKind && (this.model.settings.contractKind.balloon === true || this.model.settings.contractKind.calculationTypeCode === 'L')) {
      mileageParam = this.model.settings.mileage;
    }

    customerData.mileage = mileageParam;
    customerData.currentMileage = this.conditionParams.currentMileage != null ? this.conditionParams.currentMileage : '';
    customerData.firstRegistrationDate = this.conditionParams.firstRegistrationDate != null ? this.conditionParams.firstRegistrationDate : '';
    customerData.fuelType = this.conditionParams.fuelType != null ? this.conditionParams.fuelType : '';
    customerData.engineType = this.conditionParams.engineType != null ? this.conditionParams.engineType : '';
    customerData.purchaseBattery = this.conditionParams.purchaseBattery != null ? this.conditionParams.purchaseBattery : '';
    customerData.conditioncode = this.model.settings.conditionCode;
    customerData.callingSystem = this.determineCallingSystem(this.model.view.callingSystem);
    customerData.calculationTypeCode = this.model.settings.contractKind.calculationTypeCode;
    customerData.contractKindCode = this.model.settings.contractKind.contractKindCode;
    customerData.residualValuePrice = this.model.view.currentResult.residualValuePrice;
    customerData.residualValuePercent = this.model.view.currentResult.residualValuePercent;
    customerData.freeText = this.conditionParams.freeText;
    customerData.vehicleNumber = this.conditionParams.vehicleNumber;

    let decisionData: any = {};
    decisionData.customerData = customerData;
    return decisionData;
  }

  getPriceErrorMessage() {
    return 'Fahrzeugpreis ist zwischen ' + Math.round(this.model.settings.minVehiclePrice) + ' €  und ' + Math.round(this.model.settings.maxVehiclePrice) + ' € möglich';
  }

  ngAfterViewInit() {
    this.tooltipElements.changes.subscribe((next: QueryList<ElementRef>) => {
        if (this.tooltipsInitialized) {
          return;
        }
        let allTooltipsInitialized: boolean = true;
        next.forEach((item) => {
          if (item.nativeElement.getAttribute('tooltip') == null) {
            allTooltipsInitialized = false;
            return;
          }
        });
        if (allTooltipsInitialized) {
          this.tooltipsInitialized = true;
        }
      }
    );
  }

  getTooltipContractKind() {
    let text = '<ul class="tippy-content__text__list" id="tooltip_content_contract_kind">';
    this.productInfo.forEach(info => {
      text += '<li>' + info + '</li>';
    });
    text += '</ul>';
    return text;
  }

  protected readonly environment = environment;

  private setContractKind(contractKind: any) {
    this.model.settings.contractKind = contractKind;
    this.contractKind.set(contractKind);
  }
}
